export default __webpack_public_path__ + "static/media/icon-contact-us.c5933c24.webp";